<template>
    <div class="contentPage">
        <router-view />
    </div>
</template>
<script>
export default { name: "Settings" };
</script>
<style lang="scss" scoped>
@import 'settings';
</style>
